<script setup lang="ts">
import { computed } from "vue";

import { useBrandStore, useCaseFileStore, useEvidenceStore } from "@/stores";

withDefaults(defineProps<{ fileReference: string }>(), {  })

const bookmarkCategories = computed(() => {
  return useEvidenceStore()
    .availableCategoriesWithEvidences.map((c) => ({
      name: c.name,
      entries: c.entries.filter((e) => e.fileReference === __props.fileReference),
    }))
    .filter((c) => c.entries.length > 0);
});

const lensConfig = computed(() => useBrandStore().viewerConfig.evidenceThemes?.highlightColors ?? {});

const selectedThemes = computed(() => {
  const themes = useCaseFileStore().selectedThemes;
  if (themes == null) return;
  return themes.reduce((acc, cur) => acc.add(cur), new Set<string>());
});

const isSelected = (categoryName: string) => selectedThemes.value == null || selectedThemes.value.has(categoryName);
const toggleCategory = (categoryName: string) => useCaseFileStore().setSelectedThemes(categoryName);
</script>
<template>
  <div
    v-if="bookmarkCategories.length > 0"
    class="tw-flex tw-w-full tw-flex-wrap tw-justify-center tw-gap-x-2 tw-gap-y-1 tw-border-b tw-bg-white tw-p-1"
  >
    <button
      v-for="category in bookmarkCategories"
      :key="category.name"
      class="tw-flex tw-cursor-pointer tw-items-center tw-gap-2 tw-rounded-md tw-border tw-p-1 tw-text-xs focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-1 focus-visible:tw-outline-gray-800"
      :class="
        isSelected(category.name)
          ? 'tw-border-gray-800 tw-bg-white tw-text-gray-900 hover:tw-bg-gray-100 active:tw-bg-gray-200'
          : 'tw-border-gray-700 tw-bg-gray-200 tw-text-gray-700 hover:tw-bg-gray-200 hover:tw-text-gray-700 active:tw-bg-gray-400 active:tw-text-gray-800'
      "
      :aria-pressed="isSelected(category.name)"
      @click="() => toggleCategory(category.name)"
    >
      <span
        v-if="lensConfig[category.name] != null"
        aria-hidden="true"
        class="tw-size-2 tw-rounded-sm"
        :style="{ backgroundColor: isSelected(category.name) ? lensConfig[category.name] : 'gray' }"
      />
      {{ category.name }}
    </button>
  </div>
</template>
